import { jsx as _jsx } from "theme-ui/jsx-runtime";
/** @jsxImportSource theme-ui */
import { ErrorMessage as BaseErrorMessage } from "formik";
import { useFormTheme } from ".";
import { Text } from "@bottlebooks/gatsby-design-system";
export default function ErrorMessage(props) {
    const theme = useFormTheme();
    return (
    // @ts-ignore
    _jsx(BaseErrorMessage, Object.assign({ component: Text, variant: "small", sx: Object.assign({ color: "brand.warningRed" }, theme === null || theme === void 0 ? void 0 : theme.error) }, props)));
}
//# sourceMappingURL=ErrorMessage.js.map